function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st1{stroke:#FFFFFF;stroke-width:22;stroke-linecap:round;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M252,73.6c-22.1,0-40,17.9-40,40c0,16.4,9.9,30.5,24.1,36.7v39.4c0,28.6-25.1,52-56,52 c-30,0-54.7-22.1-55.9-49.6c35.9-7.5,63.9-39.7,63.9-78.8V35.9c0-5.7-4.1-10.7-9.6-11.8l-31.5-6.3c-6.5-1.3-12.8,2.9-14.1,9.4 l-1.6,7.9c-1.3,6.5,2.9,12.8,9.4,14.1l15.3,3V113c0,26.4-21.1,48.3-47.6,48.6c-26.7,0.3-48.4-21.3-48.4-48l0-61.3l15.4-3.1 c6.5-1.3,10.7-7.6,9.4-14.1l-1.5-7.9c-1.3-6.5-7.6-10.7-14.1-9.4l-31.4,6.2c-5.6,1.1-9.6,6-9.6,11.8v77.7c0,38.6,27.6,71,64.1,78.4 c1.3,45.3,40.3,81.6,87.9,81.6c48.5,0,88-37.7,88-84v-39.4c14.1-6.2,24-20.2,24-36.6C292,91.5,274.1,73.6,252,73.6z M252,125.6 c-6.6,0-12-5.4-12-12s5.4-12,12-12s12,5.3,12,12S258.6,125.6,252,125.6z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M484.8,256.8l-33.1-33.1c-4.9-4.9-12.7-4.9-17.6,0s-4.9,12.7,0,17.6l8.3,7.8l-19.7,19.7l-28.5-28.5 c-4.9-4.9-12.7-4.9-17.6,0c-4.4,4.4-4.6,11.1-1.1,16l77.2,77.2c2.2,1.6,4.7,2.6,7.2,2.6c3.2,0,6.4-1.2,8.8-3.6 c4.9-4.9,4.9-12.7,0-17.6l-28.5-28.5l19.7-19.7l7.8,7.8c2.4,2.4,5.6,3.6,8.8,3.6s6.4-1.2,8.8-3.6 C490.1,269.6,490.1,261.7,484.8,256.8z M332,299.8l30.3,30.3c3.2,3.2,3.2,8.5,0,11.7c-1.6,1.6-3.8,2.4-5.9,2.4s-4.2-0.8-5.9-2.4 l-30.3-30.3L298.8,333l30.3,30.3c3.2,3.2,3.2,8.5,0,11.7c-1.6,1.6-3.8,2.4-5.9,2.4s-4.2-0.8-5.9-2.4l-30.3-30.3l-20.4,20.3 c-6.2,6.2-9.7,14.7-9.7,23.5v45.9l-29.5,29.5c-4.9,4.9-4.9,12.7,0,17.6c2.4,2.4,5.6,3.6,8.8,3.6s6.4-1.2,8.8-3.6l29.5-29.5h45.9 c8.8,0,17.2-3.5,23.4-9.7l97.1-97.1L363.9,268L332,299.8z"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 63,
  y1: 452,
  x2: 459,
  y2: 107
});

var SvgMisServicios = function SvgMisServicios(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMisServicios, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mis_servicios.f0abf479.svg";
export { ForwardRef as ReactComponent };